import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import Toastr from 'toastr2'
import Qs from 'qs'

const toastr = new Toastr()

function startLoading() {
  $("#global-loader").modal()
}
function endLoading() {
  $("#global-loader").modal("hide")
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
};
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
};

// create an axios instance
const service = axios.create({
  baseURL: process.env.APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.headers["hideLoading"]!=true) {
      showFullScreenLoading();
    }

    if(getToken()!=null){
      config.headers['X-Token'] = getToken()
    }
    /*
    if (config.url.indexOf('loginTest')<0 || config.url.indexOf('/fair/index')<0) {
      let token = getToken()
      if (token != null) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation

        config.headers['X-Token'] = getToken()
      } else {
        window.location.href = 'http://www.hiturnjob.com'
      }
    }*/
    let site = localStorage.getItem('site')
    if (site != null) {
      config.headers['AppId'] = JSON.parse(site)['id']
    }
    //store.dispatch("app/showWaiting")
    return config
  },
  error => {
    // do something with request error
    //store.dispatch("app/closeWaiting")
    tryHideFullScreenLoading();
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    //store.dispatch("app/closeWaiting")
    // if the custom code is not 20000, it is judged as an error.
    tryHideFullScreenLoading();
    if (res.code !== 20000) {
      
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if(res.code === 50014){
        window.location.href = 'http://www.hiturnjob.com'
      }
      if (res.code === 50008 || res.code === 50012) {
        // to re-login
        /*
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/requestToken').then(() => {
            location.reload()
          })
        })
        */
      }
      toastr.warning(res.message || '服务器执行异常')
      return Promise.reject( res.message || '服务器执行异常')
    } else {
      return res.properties
    }
  },
  error => {
    //store.dispatch("app/closeWaiting")
    tryHideFullScreenLoading();
    toastr.warning('网络访问错误')
    return Promise.reject('网络访问错误')
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js